"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VIcon_vue_1 = __importDefault(require("./scraps/VIcon.vue"));
exports.default = vue_1.default.extend({
    name: "Window",
    components: { VIcon: VIcon_vue_1.default },
    props: {
        icon: { type: String },
        title: { type: String },
        description: { type: String }
    },
    computed: {
        translatedTitle: function () {
            return this.$lang(this.title);
        },
        translatedDescription: function () {
            return this.$lang(this.description);
        }
    }
});
